<template>
	<div class="footer">
		<div class="top">
			<div class="container">
				<div class="partner">
					<h5>合作伙伴</h5>
					<ul>
						<li>
							<img src="@/static/img/footer/playTech.png" alt="partner" width="132" />
						</li>
						<li>
							<img src="@/static/img/footer/bbin.png" alt="partner" width="66" />
						</li>
						<li>
							<img src="@/static/img/footer/microGaming.png" alt="partner" width="113" />
						</li>
						<li>
							<img src="@/static/img/footer/asiaGaming.png" alt="partner" width="84" />
						</li>
						<li>
							<img src="@/static/img/footer/orientalGame.png" alt="partner" width="73" />
						</li>
					</ul>
				</div>
				<div class="payChannel">
					<h5>支付机构</h5>
					<ul>
						<li>
							<img src="@/static/img/footer/apiPay.png" alt="partner" width="85" />
						</li>
						<li>
							<img src="@/static/img/footer/wechatPay.png" alt="partner" width="105" />
						</li>
						<li>
							<img src="@/static/img/footer/unionPay.png" alt="partner" width="129" />
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="bottom">
			<div class="container">
				<ul>
					<li>
						<router-link to="help">关于我们</router-link>
					</li>
					<li>
						<router-link to="four">责任博彩</router-link>
					</li>
					<li>
						<router-link to="second">彩种介绍</router-link>
					</li>
					<li>
						<router-link to="sven">使用条款</router-link>
					</li>
					<li>
						<router-link to="three">玩法介绍</router-link>
					</li>
				</ul>
				<p>© 2022 {{ SysName }} ALL Rights Reserved</p>
			</div>
		</div>
	</div>
</template>

<script>
import { SysKey } from "@/util/sysconfig";
export default {
	name: "footer-dom",
	data() {
		return {
			SysName: SysKey("SysName").SysValue, // 站点名
		};
	},
};
</script>

<style lang="scss" scoped>
.footer {
	.container {
		max-width: 1160px;
		margin: 0 auto;
	}
	.top {
		max-width: 1920px;
		padding: 27px 0 24px;
		background-color: #d3dbee;
		.container {
			display: flex;
			align-items: flex-start;
			justify-content: center;
		}
		.partner {
			margin-right: 94px;
		}
		.partner,
		.payChannel {
			> ul {
				display: flex;
				li {
					margin-right: 28px;
				}
			}
			> h5 {
				font-size: 18px;
				font-family: "PingFangSC-Semibold";
				color: #6455fe;
				margin-bottom: 33px;
			}
		}
	}
	.bottom {
		background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);
		padding: 30px 0 26px;
		font-family: "PingFangSC-Regular";
		color: #ffffff;
		ul {
			display: flex;
			align-items: center;
			justify-content: center;
			li {
				margin: 0 10px;
				font-size: 14px;
				&:not(:last-child)::after {
					content: "|";
					margin-left: 10px;
				}
				a {
					color: #ffffff;
					&:visited {
						color: #ffffff;
					}
				}
			}
		}
		p {
			text-align: center;
			font-size: 12px;
			margin-top: 5px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue